import { i, s, x } from '../../lit-element.js';
import { o } from '../../class-map.js';
import { reset } from '../../styles/reset.style.js';
import { links } from '../../styles/links.style.js';
import '../../directive.js';

const style = i`
  :host {
    background-color: rgba(192, 231, 243, 0.2);
    border: 1px solid #c0e7f3;
    display: block;
    font-size: 16px;
    line-height: 1.5;
    padding: 1.5em 1em;
  }

  :host([hidden]) {
    display: none;
  }

  p {
    font-size: 0.875em;
    margin-top: 0.75em;
    text-align: center;
  }

  .terms {
    overflow-y: hidden;
  }

  .terms.full-terms {
    height: 100%;
  }
`;

class RefiTermsConditions extends s {
  constructor() {
    super();
    this.startingHeight = '140px';
    this.toggleText = `+ Show full`;
    this.showFullTerms = false;
    this.onWindowResize = () => {
      if (this.showFullTerms || !this.alwaysShow || !this.expandable) {
        return;
      }
      this.determineTermsHeight(this.alwaysShow);
    };
  }

  static get properties() {
    return {
      alwaysShow: { type: String, attribute: 'always-show' },
      expandable: { type: Boolean, attribute: true },
      showFullTerms: { type: Boolean, attribute: false },
      startingHeight: { type: String, attribute: 'starting-height' },
      toggleText: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [reset, links, style];
  }

  render() {
    return x`
      <slot name="checkbox"></slot>
      <div class="terms ${o({ 'full-terms': !this.expandable })}">
        <slot></slot>
      </div>
      ${this.expandable ? x` <p><a href="#" class="grv-link" @click="${this.toggleShowMoreLessText}">${this.toggleText} terms and conditions</a></p> ` : ''}
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.onWindowResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onWindowResize);
    super.disconnectedCallback();
  }

  firstUpdated() {
    this.termsDiv = this.shadowRoot.querySelector('.terms');
    if (this.expandable) {
      this.determineTermsHeight(this.alwaysShow);
    }
  }

  determineTermsHeight(className) {
    if (!className) {
      this.setTermsHeight(this.startingHeight);
      return;
    }
    const children = Array.from(this.getElementsByClassName(className));
    if (!children || children.length === 0) {
      this.setTermsHeight(this.startingHeight);
      return;
    }
    const itemHeights = children.map(child => child.offsetHeight + parseInt(window.getComputedStyle(child).marginTop || 0, 10));
    this.setTermsHeight(`${itemHeights.reduce((acc, curr) => acc + curr)}px`);
  }

  setTermsHeight(height) {
    this.termsDiv.style.height = height;
  }

  toggleShowMoreLessText(ev) {
    ev.preventDefault();
    this.showFullTerms = !this.showFullTerms;
    this.toggleText = this.showFullTerms ? `- Show less` : `+ Show full`;
    if (this.showFullTerms) {
      this.setTermsHeight('100%');
      return;
    }
    this.determineTermsHeight(this.alwaysShow);
  }
}

export { RefiTermsConditions };
